import type { ReactNode } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { useTheme } from '@/hooks/useTheme';

interface ThemeProviderWrapperProps {
  children: ReactNode;
}

/**
 * Theme provider that dynamically switches fonts based on current language
 * English: Roboto-based fonts
 * Chinese: PingFang SC / Noto Sans CJK SC based fonts
 */
export default function ThemeProviderWrapper({ children }: ThemeProviderWrapperProps) {
  const theme = useTheme();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
